import { render, staticRenderFns } from "./APPurReturnHistory.vue?vue&type=template&id=723ae7ab&scoped=true&"
import script from "./APPurReturnHistory.vue?vue&type=script&lang=js&"
export * from "./APPurReturnHistory.vue?vue&type=script&lang=js&"
import style0 from "./APPurReturnHistory.vue?vue&type=style&index=0&id=723ae7ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ae7ab",
  null
  
)

component.options.__file = "APPurReturnHistory.vue"
export default component.exports